// src/services/notificationsService.js
// API центра уведомлений (data_service, снаружи /notifications/…).
// Список — /notifications/ со слешем: без него nginx отдал бы страницу фронтенда.
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { attachAuthInterceptors } from './attachAuthInterceptors';
import { refreshSession, reauthenticateTelegram } from './authService';

const api = axios.create({ baseURL: API_BASE_URL });
attachAuthInterceptors(api, { refreshSession, reauthenticateTelegram });

export const fetchNotifications = async ({ limit = 30, before } = {}) => {
  const params = { limit };
  if (before) params.before = before;
  const response = await api.get('/notifications/', { params });
  return response.data; // { items, next_before }
};

export const fetchUnreadCount = async () => {
  const response = await api.get('/notifications/unread_count');
  return response.data?.count ?? 0;
};

export const markNotificationRead = async (id) => {
  await api.post(`/notifications/${id}/read`);
};

export const markAllNotificationsRead = async () => {
  const response = await api.post('/notifications/read_all');
  return response.data?.updated ?? 0;
};

export const fetchNotificationSettings = async () => {
  const response = await api.get('/notifications/settings');
  return response.data; // { enabled_groups, disabled_server_ids, groups, servers }
};

export const saveNotificationSettings = async ({ enabled_groups, disabled_server_ids, shift_summary, shift_summary_mode, stock_negative }) => {
  const response = await api.put('/notifications/settings', {
    enabled_groups,
    disabled_server_ids,
    shift_summary,
    shift_summary_mode,
    stock_negative,
  });
  return response.data;
};

// --- web push ---

export const fetchPushConfig = async () => {
  const response = await api.get('/notifications/push/config');
  return response.data; // { enabled, public_key }
};

// subscription — PushSubscription.toJSON() из браузера
export const savePushSubscription = async (subscription) => {
  await api.post('/notifications/push/subscribe', subscription);
};

export const deletePushSubscription = async (endpoint) => {
  await api.delete('/notifications/push/subscribe', { data: { endpoint } });
};

// --- оповещения админам: отключение по области (сервер iiko, ключ iikoCloud) ---

export const fetchAlertMutes = async () => {
  const response = await api.get('/notifications/alerts/mutes');
  return response.data?.mutes || [];
};

export const muteAlertScope = async (scope, title) => {
  const response = await api.post('/notifications/alerts/mutes', { scope, title });
  return response.data?.mutes || [];
};

export const unmuteAlertScope = async (scope) => {
  const response = await api.delete('/notifications/alerts/mutes', { params: { scope } });
  return response.data?.mutes || [];
};
